/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';

const InfoCompanyStatus = ({ profile }) => {
  return (
    <div className='info flex'>
      <div className='info__img flex-center'>
        <img src={profile?.profile_img} alt='' />
      </div>
      <div className='info__content'>
        <h4>{profile?.name}</h4>
        <p>Doanh nghiệp đã được xác minh</p>
        <div className='flex' style={{ flexDirection: 'column' }}>
          <div
            className='flex'
            style={{
              border: 'solid 1px #2196F3',
              color: '#2196F3',
              marginTop: '10px',
              padding: '3px 10px',
              borderRadius: '7px',
            }}
          >
            <span>
              Lượt phản hồi: {profile?.like_count ? profile?.like_count : 0}
            </span>
          </div>
          <div
            className='flex'
            style={{
              border: 'solid 1px #2196F3',
              color: '#2196F3',
              marginTop: '10px',
              padding: '3px 10px',
              borderRadius: '7px',
            }}
          >
            <span>
              Lượt đăng ký:{' '}
              {profile?.register_count ? profile?.register_count : 0}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoCompanyStatus;
